<app-loader></app-loader>
<div class="modify-model">
    <div class="payment-option">
        <p>Modify Booking</p>
        <div class="custom-close">
            <img src="../../assets/images/new-close.svg" (click)="close()" alt="Close"/>
        </div>
    </div>
    <div *ngIf="errorMessage" class="information-icon">
        <h4 class="fill-error">{{errorMessage}}</h4>
    </div>
    <div class="modify-output date-filter">
        <form [formGroup]="bookingForm" (ngSubmit)="Submit()">
            <div *ngIf="!isSpotChange" class="date-outer">

                <label for="arrivalDate">Arrival Date <span class="custom-star">*</span></label>
                <div class="custom-select2 custom-date-calender">
                    <div #focusTrap tabindex="0"></div>
                    <p-calendar id="arrivalDate" #startDate formControlName="arrivalDate" placeholder="Select Date"
                        dateFormat="MM dd, yy" [minDate]="minDate" (onSelect)="onInputChange('arrivalDate')"
                        [readonlyInput]="true" appendTo="body" [disabled]="bookingData?.userType !== userType.PARKER"
                        [style]="{width: '150px', 'font-size': '12px'}"></p-calendar><img [calendarOpener]="startDate"
                        src="assets/images/date-calender.png" alt="calender"/>
                </div>
            </div>

            <div *ngIf="!isSpotChange" class="date-outer">
                <label for="arrivalTime">Arrival Time <span class="custom-star">*</span></label>
                <div class="custom-select2 custom-date-calender">
                    <p-dropdown id="arrivalTime" [options]="timeOptions" formControlName="arrivalTime" placeholder="Select"
                        optionLabel="name" optionValue="value" appendTo="body" (onChange)="onInputChange('arrivalTime')"
                        [style]="{'width':'100%'}"></p-dropdown><img class="dropdown-icon"
                        src="assets/images/fill-dropdown.svg" alt=""/>
                </div>
            </div>
            <div *ngIf="!isSpotChange && (bookingData?.bookingType === 0)" class="date-outer">
                <label for="departureDate">Departure Date <span class="custom-star">*</span></label>
                <div class="custom-select2 custom-date-calender">
                    <p-calendar id="departureDate" #endDate formControlName="departureDate" appendTo="body" placeholder="Select Date"
                        dateFormat="MM dd, yy" [minDate]="depatureMinDate" (onSelect)="onInputChange('departureDate')"
                        [readonlyInput]="true" [style]="{width: '150px', 'font-size': '12px'}"></p-calendar><img
                        [calendarOpener]="endDate" src="assets/images/date-calender.png" alt="calender"/>
                </div>
            </div>
            <div *ngIf="canEditSpot() && isSpotChange" class="date-outer common-spot">
                <label for="currentSpot">Current Spot</label>
                <div class="custom-select2 custom-date-calender">
                    <p-dropdown id="currentSpot" formControlName="currentSpot" placeholder="Select" appendTo="body"
                        [options]="currentSpotOptions" optionLabel="name" optionValue="id" [style]="{'width':'100%'}"></p-dropdown><img
                        class="dropdown-icon" src="assets/images/fill-dropdown.svg" alt=""/>
                </div>
            </div>
            <div *ngIf="canEditSpot() && isSpotChange" class="date-outer common-spot">
                <label for="spot">New Spot</label>
                <div class="custom-select2 custom-date-calender">
                    <p-dropdown id="spot" formControlName="spot" placeholder="Select" appendTo="body" [options]="spotOptions"
                        optionLabel="name" optionValue="id" [style]="{'width':'100%'}"></p-dropdown><img
                        class="dropdown-icon" src="assets/images/fill-dropdown.svg" alt=""/>
                </div>
            </div>
            <div *ngIf="canEditSpot() && !isDateChange && !isSpotChange"
                class="date-outer common-spot">
                <label for="spot">Spot</label>
                <div class="custom-select2 custom-date-calender">
                    <p-dropdown id="spot" formControlName="spot" placeholder="Select" appendTo="body" [options]="spotOptions"
                        optionLabel="name" optionValue="id" [style]="{'width':'100%'}"></p-dropdown><img
                        class="dropdown-icon" src="assets/images/fill-dropdown.svg" alt=""/>
                </div>
            </div>
            <div class="save-btn">
                <p-button type="Submit" label="Continue"></p-button>
            </div>
        </form>
    </div>
</div>